var map = {
	"./1-snokratta.png": 3639,
	"./10-stodfotter-profilerad-plat.png": 6507,
	"./2-taksteg.png": 4674,
	"./3-skyddracke-hogt.png": 8912,
	"./4-glidskydd.png": 5660,
	"./5-forankringspunkt.png": 4142,
	"./9-stodfotter-falsat.png": 1801,
	"./Falsfaste_for_bandtackning_och_klicktak.png": 4438,
	"./Fasadstege-old.png": 5169,
	"./Fasadstege.png": 7509,
	"./Nockracke-old.png": 4757,
	"./Nockracke.png": 6345,
	"./Skyddsracke_taklucka.png": 9291,
	"./Snorasskydd_3_ror.png": 7319,
	"./Snorasskydd_galler.png": 2511,
	"./T_skikt.png": 4245,
	"./Takbrygga.png": 8190,
	"./Takstege-old.png": 1646,
	"./Takstege.png": 778,
	"./Universalfaste-for-slata-tak.png": 7279,
	"./Universalfaste_for_profilerad_plat.png": 731,
	"./Vajer_takst_brygga_fasadst_utan_tak_2.png": 7581,
	"./betongpanna-med-barlakt.png": 9154,
	"./betongpanna-med-undertak.png": 843,
	"./tegelpanna_med_barlakt.png": 4158,
	"./tegelpanna_med_undertak.png": 2151
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2253;